import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function O2HeaderLinks(props) {
  var children = props.children,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className"]);

  var classes = classNames(className, "o2-header__links");
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, attributes), children);
}

O2HeaderLinks.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export default O2HeaderLinks;